import type { FC } from "react";

import {
  AnimatedHeaderSection,
} from "@/ui/components/layout/AnimatedHeaderSection";
import { Column } from "@/ui/components/layout/Column";
import { Grid } from "@/ui/components/layout/Grid";
import { Section } from "@/ui/components/layout/Section";
import { Button } from "@/ui/components/primitives/Button";
import { TextTitle } from "@/ui/components/typography/TextTitle";
import { cn } from "@/ui/lib/utils";
import {
  ANIMATED_HEADER_SPLASH_DEFAULTS,
  TAnimatedHeaderSplashProps,
} from "@/ui/components/sections/hero/AnimatedHeaderSplash";

export const AnimatedHeaderSplash: FC<TAnimatedHeaderSplashProps> = (
  {
    title,
    buttons,
    illustration = ANIMATED_HEADER_SPLASH_DEFAULTS.illustration,
    background = ANIMATED_HEADER_SPLASH_DEFAULTS.background,
    className,
    containerClassName,
    ...props
  },
) => (
  <Section
    {...props}
    data-component="AnimatedHeaderSplash"
    className={cn(className)}
  >
    <AnimatedHeaderSection
      illustration={illustration}
      background={background}
      containerClassName={cn(
        "pb-8 md:pb-12",
        containerClassName,
      )}
    >
      <Grid gap={{ default: "4", xl: "5" }}>
        <Column>
          <TextTitle
            tag="h1"
            align="center"
            whitespace="balance"
            isResponsive={false}
            className="mx-auto max-w-3xl tracking-[-0.02em]"
          >
            { title }
          </TextTitle>
        </Column>
        <Column>
          <Grid className="mx-auto w-full max-w-lg">
            <Column
              spans={{ default: "12", xl: buttons.secondary ? "6" : "12" }}
              className={cn(!buttons.secondary && "flex justify-center")}
            >
              <Button
                {...buttons.primary}
                variant={buttons.primary.variant ?? "default"}
                size={buttons.primary.size ?? "lg"}
                width={buttons.primary.width ?? "fill"}
              />
            </Column>
            { buttons.secondary ? (
              <Column spans={{ default: "12", xl: "6" }}>
                <Button
                  {...buttons.secondary}
                  variant={buttons.secondary.variant ?? "secondary"}
                  size={buttons.secondary.size ?? "lg"}
                  width={buttons.secondary.width ?? "fill"}
                />
              </Column>
            ) : null }
          </Grid>
        </Column>
      </Grid>
    </AnimatedHeaderSection>
  </Section>
);

AnimatedHeaderSplash.displayName = "AnimatedHeaderSplash";
